// extracted by mini-css-extract-plugin
export default {"renderFrame":"renderFrame-hnHZX","archivedAlert":"archivedAlert-cJHZ8"};